/* eslint-disable @angular-eslint/directive-class-suffix */
/* eslint-disable @angular-eslint/directive-selector */
/* eslint-disable @angular-eslint/no-host-metadata-property */
import { Directive, EventEmitter, Input, Output } from '@angular/core';

export type SortColumn = keyof any | '';
export type SortDirection = 'asc' | 'desc' | '';
const rotate: { [key: string]: SortDirection } = { 'asc': 'desc', 'desc': '', '': 'asc' };

export interface listSortEvent {
  column: SortColumn;
  direction: SortDirection;
}

@Directive({
    selector: 'th[listsortable]',
    host: {
        '[class.asc]': 'direction === "asc"',
        '[class.desc]': 'direction === "desc"',
        '[class.no-sort]': 'direction === ""',
        '(click)': 'rotate()'
    },
    standalone: false
})
export class NgbdListSortableHeader {

  @Input() listsortable: SortColumn = '';
  @Input() direction: SortDirection = '';
  @Output() listsort = new EventEmitter<any>();

  rotate() {
    this.direction = rotate[this.direction];
    this.listsort.emit(this.listsortable);
  }
}
